import { dateFormats, DateObject, useIntl } from '@capsicum/common';
import { ParticipationCard } from '@capsicum/common-web';
import { PollIcon } from '@capsicum/common-web/icons';
import { useLedgerSummaryInUseDetails } from '@capsicum/features/wallet/shared';
import styled from 'styled-components';

import {
	SectionCardListWrapper,
	SectionHeader,
	SectionSubtitle,
	SectionTitle,
	SectionWrapper
} from '../WalletPartnerDetails.styled';

type InUseSectionProps = {
	ledgerId: string;
	shortCode: string;
};

export const InUseSection = ({ ledgerId, shortCode }: InUseSectionProps) => {
	const { $t } = useIntl();

	const { format } = dateFormats;
	const { inUseDetails } = useLedgerSummaryInUseDetails(ledgerId);

	const pollTitle = $t('wallet.partnerWallet.inUse.poll');

	if (!inUseDetails || !inUseDetails.inUseDetailsData?.length) {
		return null;
	}

	return (
		<SectionWrapper>
			<SectionHeader>
				<SectionTitle>{$t('wallet.partnerWallet.inUse.title')}</SectionTitle>
				<SectionSubtitle>{`${Math.round(Number(inUseDetails.inUseBalanceData))} ${shortCode}*`}</SectionSubtitle>
			</SectionHeader>
			<SectionCardListWrapper>
				{inUseDetails.inUseDetailsData?.map((item, i) => {
					return (
						<ParticipationCard
							caption={format(item.createdAt, 'DD/MM/YYYY')}
							chartLabel={`${Math.round(Number(item.amount))} ${shortCode}`}
							color={item.color}
							endDate={new DateObject(item.unlockAt)}
							icon={PollIcon}
							key={i}
							startDate={new DateObject(item.createdAt)}
							testID={`walletPartnerDetails-inUseSection-card-${i}`}
							text={item.title}
							title={pollTitle}
						/>
					);
				})}
			</SectionCardListWrapper>
			<S.InfoText>{$t('wallet.partnerWallet.inUse.infoText')}</S.InfoText>
		</SectionWrapper>
	);
};

namespace S {
	export const InfoText = styled.div`
		${({ theme }) => theme.fonts.text.text5};
		color: ${({ theme }) => theme.colors.text.main.subtle};
	`;
}
